"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Card;

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("@dom/config"));

var _BlurImage = _interopRequireDefault(require("../BlurImage"));

require("./card.scss");

function Card(props) {
  var images = props.images,
      children = props.children,
      imageAlt = props.imageAlt;

  var _ref = images || {},
      medium = _ref.medium,
      small = _ref.small;

  return _react["default"].createElement("div", {
    className: "custom-card"
  }, _react["default"].createElement("div", {
    className: "custom-card-image"
  }, _react["default"].createElement(_BlurImage["default"], {
    alt: imageAlt,
    src: "".concat(_config["default"].RESOURCE_URL, "/").concat(medium),
    placeholder: "".concat(_config["default"].RESOURCE_URL, "/").concat(small)
  })), children);
}